import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function PerformerListSkeleton() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="flex flex-col bg-card">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-2.5 border-b border-border px-4 py-4 last:border-0"
          >
            <Skeleton className="size-10 flex-none rounded-full" />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <Skeleton className="h-3.5 w-32" />
              <div className="flex items-center gap-1.5">
                <Skeleton className="size-3.5 flex-none rounded" />
                <Skeleton className="h-3 w-28" />
              </div>
            </div>
            <Skeleton className="h-3 w-12 flex-none" />
            <Skeleton className="size-4 flex-none rounded" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-28" />
        <Skeleton className="h-3 w-10" />
        <Skeleton className="ml-auto h-3 w-32" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
      </div>
      {Array.from({ length: 10 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[42px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="size-[30px] flex-none rounded-full" />
          <Skeleton className="h-3 w-28" />
          <Skeleton className="h-3 w-10" />
          <Skeleton className="ml-auto h-3 w-32" />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="size-4 flex-none rounded" />
        </div>
      ))}
    </div>
  );
}
